import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=69495e47&scoped=true&"
import script from "./StudentEdit.vue?vue&type=script&lang=js&"
export * from "./StudentEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69495e47",
  null
  
)

export default component.exports